import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { HvGrid, HvTypography } from "@hitachivantara/uikit-react-core";

import Container from "components/layout/Container";

import SopTable from "components/sop/SopTable";
import { ModuleNames, ModulePolicyTypes } from "lib/api/userSettings";
import { UserDataContext } from "lib/context/UserDataContext";
import NotFound from "components/common/NotFound";

const Sop: React.FC = () => {
  const { t } = useTranslation("sop");

  return (
    <Container>
      <HvGrid container>
        <HvGrid item xs={12}>
          <HvTypography variant="mTitle">{t("title")}</HvTypography>
        </HvGrid>
        <HvGrid item xs={12}>
          <SopTable />
        </HvGrid>
      </HvGrid>
    </Container>
  );
};
export const SopAuth: React.FC = () => {
  const { hasModulePolicy } = useContext(UserDataContext);
  const hasRight = useMemo(() => {
    return hasModulePolicy(
      ModuleNames.incidentManagement,
      ModulePolicyTypes.sop
    );
  }, [hasModulePolicy]);
  return (
    <>
      {hasRight ? (
        <Container noHVContainer>
          <Sop />
        </Container>
      ) : (
        <NotFound />
      )}
    </>
  );
};
export default Sop;
